import { useCallback, useEffect, useState } from "react";
import { useActiveAccount } from "thirdweb/react";
import { parseUnits } from "ethers";
// import Skeleton from "react-loading-skeleton";
import ConnectWalletButton from "../ConnectWalletButton";
import Button from "../SecondaryButton";
import StakeInput from "../StakeInput";
import { NotificationType, showToastNotification } from "@/utils/notification";
import RedeemSuccessfulModal from "../Modals/RedeemSuccessfulModal";
import ErrorModal from "../Modals/ErrorModal";
import { EXCHANGE_RATE, networkMap, networkType } from "@/config";
import { getUsponInfo, redeemUspon } from "@/services/uspon";
import { useTrackUserEvent } from "@/utils/analytics";
import ArrowSeparator from "../ArrowSeparator";
import { withdrawFromEscrow } from "@/services/escrow";
import { getFizzNodesByWallet } from "@/services/subgraph";

interface IProps {
  uSponBalance: number | null;
  isLoading: boolean;
  uSponWalletBalance: number | null;
}

const Redeem = ({ uSponBalance, isLoading, uSponWalletBalance }: IProps) => {
  console.log("uSponBalance", uSponBalance);
  console.log("isLoading", isLoading);
  console.log("uSponWalletBalance", uSponWalletBalance);
  const trackUserEvent = useTrackUserEvent();
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const [uSponInfo, setUsponInfo] = useState<{
    shares: string;
    proof: `0x${string}`[];
  } | null>(null);
  const [isRedeeming, setIsRedeeming] = useState(false);

  const activeAccount = useActiveAccount();

  const redeemToSPON = async () => {
    setIsRedeeming(true);
    if (activeAccount && uSponInfo) {
      if (
        uSponWalletBalance !== null &&
        uSponWalletBalance < Number(uSponInfo?.shares)
      ) {
        try {
          let fizzId = BigInt(0);
          const fizzNodes = await getFizzNodesByWallet(activeAccount.address);
          if (fizzNodes.length > 0) {
            fizzId = BigInt(fizzNodes[0].fizzId);
          }
          const txnHash = await withdrawFromEscrow(
            activeAccount,
            parseUnits(uSponInfo.shares, 6),
            fizzId
          );
          showToastNotification({
            title: "You've successfully withdrawn!",
            message: "",
            txnLink: `${networkMap[networkType].blockExplorerUrls[0]}/tx/${txnHash}`,
            timestamp: new Date(),
            type: NotificationType.Success,
          });
        } catch (e) {
          console.log("Error while withdraw: ", e);
          showToastNotification({
            title: "Withdraw Failed",
            message:
              "Please try again or contact support if the issue persists.",
            timestamp: new Date(),
            type: NotificationType.Error,
          });
          setIsRedeeming(false);
          return;
        }
      }
      try {
        const txnHash = await redeemUspon({
          shares: parseUnits(uSponInfo.shares, 6),
          proof: uSponInfo?.proof ?? [],
          account: activeAccount,
        });
        showToastNotification({
          title: "Your redeem request has been successfully submitted.",
          message: "",
          txnLink: `${networkMap[networkType].blockExplorerUrls[0]}/tx/${txnHash}`,
          timestamp: new Date(),
          type: NotificationType.Success,
        });
        document.dispatchEvent(new Event("refreshBalance"));
        document.dispatchEvent(new Event("refreshRedeem"));
      } catch (error) {
        console.log("error while redeeming: ", error);
        setIsRedeeming(false);
        setIsErrorModalOpen(true);
      } finally {
        setIsRedeeming(false);
      }
    }
  };

  const fetchBalance = useCallback(async () => {
    if (activeAccount) {
      try {
        const { usponInfo } = await getUsponInfo(activeAccount.address);
        setUsponInfo(usponInfo);
      } catch (e) {
        console.log("error while fetching withdraw details: ", e);
      }
    } else {
      setUsponInfo(null);
    }
  }, [activeAccount]);

  useEffect(() => {
    fetchBalance();
  }, [fetchBalance]);

  console.log(uSponInfo);

  return (
    <>
      <div className="flex flex-col h-full justify-between">
        <div className="flex flex-col gap-[18px]">
          <div className="flex flex-col gap-3">
            <StakeInput
              label="Redeemable uSPON Amount"
              unit="uSPON"
              readOnly
              value={uSponInfo?.shares?.toString() || "0"}
              onChange={() => {}}
            />
            {/* <div className="flex justify-between items-center">
              {account?.address && (
                <div className="text-white font-medium text-sm flex gap-1">
                  <span>Available Balance:</span>
                  {isLoading ? (
                    <Skeleton width="100px" />
                  ) : (
                    <span>{uSponInfo?.shares} uSPON</span>
                  )}
                </div>
              )}
            </div> */}
          </div>
          <ArrowSeparator />
          <div className="flex flex-col gap-3">
            <StakeInput
              readOnly
              label="You Receive"
              unit="SPON"
              value={Number(
                (Number(uSponInfo?.shares || 0) * EXCHANGE_RATE).toFixed(6)
              ).toString()}
            />
          </div>
        </div>
        <div className="text-white">
          <b>Note:</b> Only eligible uSPON can be withdrawn.
        </div>
        {activeAccount?.address ? (
          <Button
            onClick={() => {
              trackUserEvent("Redeem Tab- Redeem Click");
              redeemToSPON();
            }}
            loading={isRedeeming}
            disabled={!uSponInfo?.shares || Number(uSponInfo?.shares) === 0}
            variant="light"
          >
            REDEEM NOW
          </Button>
        ) : (
          <ConnectWalletButton />
        )}
      </div>
      <RedeemSuccessfulModal close={() => {}} isOpen={false} />
      <ErrorModal
        close={() => setIsErrorModalOpen(false)}
        isOpen={isErrorModalOpen}
        errorTitle="Oops! Something went wrong."
        errorDescription="Your redeem request couldn't be processed. Please try again or contact support if the issue persists."
        handleTryAgain={() => {
          trackUserEvent("Redeem Error Modal- Try Again Click");
          redeemToSPON();
        }}
      />
    </>
  );
};

export default Redeem;
